import type {ComponentProps} from 'react';
import {useIntl} from 'react-intl';

import {FileAttachment} from './file-attachment';

type Props = ComponentProps<typeof FileAttachment>;

export const ImageAttachment = (props: Props) => {
    const {formatMessage} = useIntl();
    const label = formatMessage({id: 'file_attachment.open_image', defaultMessage: 'Open image'});

    return <FileAttachment {...props} label={label} />;
};
